import { useEffect } from 'react';
import { NavigateFunction, NavigateOptions, useNavigate } from 'react-router';

// Navigation service to allow navigation from outside React components like axios interceptors
let navigateRef: NavigateFunction | null = null;

const navigate = (to: string, options?: NavigateOptions) => {
  if (navigateRef) {
    navigateRef(to, options);
  } else {
    // Fallback if navigate isn't set yet
    window.location.href = to;
  }
};

// Provider component to set up navigation reference
const NavigationProvider = ({ children }: { children: React.ReactNode }) => {
  const nav = useNavigate();
  useEffect(() => {
    navigateRef = nav;
  }, [nav]);
  return <>{children}</>;
};

export { navigate, NavigationProvider };
